import React, { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { useRecoilState, useRecoilValue } from "recoil"
import {
  sizeState,
  themeState,
  userObjState,
  pagesNprofileState,
  updatedPagesObjState,
  updatedProfileObjState,
  editModeState,
  editObjState,
  editedPagesState,
  addModeState,
} from "../recoil-atom"

import { ItemTypes } from "./Constants.js"
import { useDrag, useDrop, DragPreviewImage } from "react-dnd"

import {
  Flex,
  FlexColumn,
  Input,
  Submit,
  DivRound,
  ListPages,
  PageMarks,
  GroupMarks,
  Mark,
  MarkEdit,
  MarkIcon,
} from "../styled-components-openmark"
import styled, { css } from "styled-components"

import { PlusCircle } from "@styled-icons/evaicons-solid"

import { getTextLength, cutTextLimit } from "../jace"

const LinkMarkEdit = ({ pageId, groupId, markId, mark }) => {
  const [size, setSize] = useRecoilState(sizeState)
  const [theme, setTheme] = useRecoilState(themeState)
  const [userObj, setUserObj] = useRecoilState(userObjState)
  const { pagesObj, profileObj, shortName } = useRecoilValue(pagesNprofileState)
  const [updatedPagesObj, setUpdatedPagesObj] =
    useRecoilState(updatedPagesObjState)
  const [editMode, setEditMode] = useRecoilState(editModeState)
  const [editObj, setEditObj] = useRecoilState(editObjState)
  const [editedPages, setEditedPages] = useRecoilState(editedPagesState)
  const [addMode, setAddMode] = useRecoilState(addModeState)

  const markKey = pageId + groupId + markId

  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: ItemTypes.MARK,
      item: { pageId, groupId, markId, mark },
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
      }),
    }),
    [pageId, groupId, markId, mark]
  )

  return (
    <>
      <MarkEdit
        onClick={() => {
          if (updatedPagesObj[pageId][groupId].length === markId) {
            setAddMode(true)
          }
          setEditMode(true)
          setEditObj({ pageId, groupId, markId, mark })
          // console.log(mark)
        }}
      >
        {mark.thumbnail ? (
          <MarkIcon thumbnail={mark.thumbnail} ref={drag} />
        ) : (
          <>
            {updatedPagesObj[pageId][groupId].length !== markId ? (
              <MarkIcon bgColor={mark.bgColor} color={mark.color} ref={drag}>
                {mark.title}
              </MarkIcon>
            ) : (
              <MarkIcon bgColor={mark.bgColor} color={mark.color}>
                <PlusCircle size="20" color={userObj.colors.b2} />
              </MarkIcon>
            )}
          </>
        )}
        <div>
          {getTextLength(mark.title) > 20 ? (
            <span>{cutTextLimit(mark.title, 18)}⋯</span>
          ) : (
            mark.title
          )}
        </div>
      </MarkEdit>
    </>
  )
}

export default LinkMarkEdit
